var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"},attrs:{"id":"rightMainContainer"}},[_c('operations',{on:{"pf":_vm.parent,"pf4":_vm.parent4}}),_c('div',{staticStyle:{"height":"var(--middle-space)","background":"#f4f5fa"}}),_c('navAndSearch'),_c('fileTable',{ref:"goodslist"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }